module.exports = __webpack_public_path__ + "img/9.0af91d3e.png";